import { React } from 'react';
import Grid from '@mui/material/Grid';
import { useDispatch, useSelector } from 'react-redux';
import { addMinutes } from 'date-fns';

import { filterOrders } from 'store/thunks/workQueueThunks';
import DateRangePickerFieldWithLimit from 'common/forms/DateRangePickerFieldWithLimit';

const OrderVerificationOuterFilter = () => {
  const dispatch = useDispatch();
  const filter = useSelector(({ workQueue: { orderVerification } }) => orderVerification.filter);

  const onHandleDateChange = (dateRange) => {
    const createdAtLength = dateRange?.length;
    const createdAt = createdAtLength === 1 ? dateRange[0] : undefined;

    dispatch(
      filterOrders({
        filter: {
          ...filter,
          createdAt,
          createdBetween: !createdAt ? dateRange : undefined,
        },
      })
    );
  };

  return (
    <Grid>
      <DateRangePickerFieldWithLimit
        label='Date Range'
        onDateChange={onHandleDateChange}
        initialValue={filter?.createdAt ? [filter.createdAt] : filter?.createdBetween}
        maxMonths={3}
        maxDate={addMinutes(new Date(), 60)}
      />
    </Grid>
  );
};

export default OrderVerificationOuterFilter;
